import React, { useState, useEffect } from 'react';
import './ProcedureCard.css';

export function ProcedureCard({
  id,
  title,
  description,
  images,
  imageUrl,
  formattedPrice,
  onSchedule,
  whatsappUrl,
  instagramUrl,
}) {
  const imageList = Array.isArray(images) && images.length > 0
    ? images
    : (imageUrl ? [imageUrl] : ['/images/procedures/sobrancelha-design-estrategico.jpeg']);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (imageList.length <= 1 || isPaused) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % imageList.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [imageList.length, isPaused]);

  const handleImageError = (e) => {
    e.currentTarget.src = '/images/procedures/sobrancelha-design-estrategico.jpeg';
  };

  return (
    <div
      className="proc-card"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="proc-card-image-wrap">
        {imageList.map((imgSrc, idx) => (
          <img
            key={imgSrc + idx}
            src={imgSrc}
            alt={`${title} - Foto ${idx + 1}`}
            className={`proc-card-image ${idx === currentIndex ? 'proc-card-image-active' : 'proc-card-image-hidden'}`}
            onError={handleImageError}
            loading={idx === 0 ? 'eager' : 'lazy'}
          />
        ))}

        {imageList.length > 1 && (
          <>
            <div className="proc-card-badge-count">
              <span>{currentIndex + 1}/{imageList.length} fotos</span>
            </div>

            <div className="proc-card-dots">
              {imageList.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  className={`proc-card-dot ${idx === currentIndex ? 'proc-card-dot-active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(idx);
                  }}
                  aria-label={`Ver foto ${idx + 1}`}
                />
              ))}
            </div>
          </>
        )}

        {formattedPrice && (
          <span className="proc-card-price-tag">
            {formattedPrice}
          </span>
        )}
      </div>

      <div className="proc-card-content">
        <h3 className="proc-card-title">{title}</h3>
        <p className="proc-card-desc">{description}</p>

        <div className="proc-card-actions">
          <button
            type="button"
            className="proc-btn-schedule"
            onClick={() => onSchedule(id)}
            title="Agendar online no site"
          >
            📅 Agendar Horário
          </button>

          <div className="proc-card-socials">
            <a
              href={`${whatsappUrl}&text=Olá%20Fran!%20Gostaria%20de%20saber%20mais%20e%20agendar%20o%20procedimento%20${encodeURIComponent(title)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="proc-social-icon proc-social-whatsapp"
              title="Agendar pelo WhatsApp"
            >
              <img src="/images/whatsapp-icon.png" alt="WhatsApp" />
            </a>

            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="proc-social-icon proc-social-instagram"
              title="Ver no Instagram"
            >
              <img src="/images/instagram-icon.png" alt="Instagram" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
